import moment from 'moment';
import { getRandomEnumValue, getRandomItem } from '../../utils/dummy-data';
import { BillingInvoices } from '../model/billing-invoice';
import { PlanInterval } from '../model/enum/plan-interval';
import { PaymentStatus } from '../model/enum/payment-status.enum';
import { PlanType } from '../model/enum/plan-type';
import { USER_PROFILES } from './user-profiles';

export const BILLING_INVOICES = USER_PROFILES.reduce(
  (acc: BillingInvoices[], profile) => {
    acc.push({
      id: 1,
      billingInformation: {
        id: profile.user.id!,
        profile,
        paymentMethod: getRandomItem([
          'Mastercard ending 9282',
          'Mastercard ending 7722',
          'Mastercard ending 7280',
        ]),
        vat: getRandomItem(['UK849700927', 'UK569330998']),
        billingInterval: getRandomEnumValue(PlanInterval),
        billingAddress: getRandomItem(['hello@cruip.com', 'hello@drip.com']),
        userAddress: getRandomItem([
          '34 Savoy Street, London, UK, 24E8X',
          '14 Savoy Street, London, UK, 24E8X',
        ]),
      },
      invoices: {
        data: [
          {
            id: 1,
            coverageStartDate: moment('2025-01-14T12:13:44.290907'),
            coverageEndDate: moment('2025-02-14T12:13:44.290907'),
            planType: PlanType.BASIC,
            billingInterval: PlanInterval.ANNUALLY,
            status: PaymentStatus.PAID,
            amount: 349.0,
          },
          {
            id: 2,
            coverageStartDate: moment('2025-01-14T12:13:44.290907'),
            coverageEndDate: moment('2025-02-14T12:13:44.290907'),
            planType: PlanType.STANDARD,
            billingInterval: PlanInterval.MONTHLY,
            status: PaymentStatus.CANCELLED,
            amount: 349.0,
          },
        ],
        meta: {
          total: 2,
        },
      },
    });
    return acc;
  },
  []
);
